import React, { useState, useContext , useEffect } from "react";
import { Box, Grid, Paper, Chip, Typography , CircularProgress , Autocomplete , TextField , Tooltip , IconButton } from "@mui/material";
import { useDroppable } from "@dnd-kit/core";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
import TicketModal from "./TicketModal";
import AuthContext from "../../context/AuthContext";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { DeleteModal, EditModal } from "./TicketModals";
import ApiService from '../../functions/apiService';
import './ticketing.css'
import { Row , Col } from "react-bootstrap";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import { toast } from "react-toastify";

export const SortableItem = ({ item, activeItem, ticketApi, ticketType  , TicketData }) => {
  const { user , permission } = useContext(AuthContext);
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item.id });
  const limit = 50;
  const titleLimit = 13;
  const [show, setShow] = useState(false);
	const [deleteModal , setDeleteModal] = useState(false);
	const [editModal , setEditModal] = useState(false);
	const [editId , setEditId] = useState('');
	const [loading , setLoading] = useState(false);
	const [assignModal , setAssignModal] = useState(false);
	const [employees , setEmployees] = useState([]);
	const [ticketAssignTo, setTicketAssignTo] = useState(null); 
	const [selectedId , setSelectedId] = useState('');
	const [selectedEmp , setSelectedEmp] = useState('');

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    marginBottom: "14px",
    backgroundColor: "white",
    cursor: "grab",
    maxWidth: "100%",
  };

	if (activeItem?.id === item.id) {
    return <></>; 
  }

  	const loadEmployees = () => {
		ApiService.get('/employees-list?search=')
			.then(({ data }) => {
				var tempArr = []
				data?.data.map((emp) => {
					var obj = {
						label: `${emp?.employee_assignment?.EA_Rank} ${emp?.fullName}`,
						value: emp?.Emp_Code
					}
					tempArr.push(obj)
				})
				setEmployees(tempArr)
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			})
	}

	// useEffect(()=>{
	// 	loadEmployees()
	// }, [])

	const UpdateEmployee = () => {
		const body = {
		  "ticket_id" : selectedId,
		  "assigned_to" : ticketAssignTo?.value
		}
		ApiService.post('/tickets/checklists/update-assignedTo', body)
			.then((data) => {
				toast.success(data?.message || 'Updated Successfully')
				setAssignModal(false);
				setTicketAssignTo(null)
				TicketData()
		}).catch((error) => {
		  		toast.error(error?.data?.message || error?.message || 'error');
		})
	};

	// useEffect(() => {
	// 	if (employees?.length && selectedEmp) {
	// 		const defaultObj = employees.find(e => e.value === selectedEmp);
	// 		setTicketAssignTo(defaultObj || null);
	// 	}
	// }, [employees, selectedEmp]);

  

  const assigneeName = `${item?.employee_first_name || ''} ${item?.employee_last_name || ''}`.trim();
  const initials = assigneeName
    ? assigneeName.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()
    : '?';
  const locationLabel = item?.ticket_type === 'location' || item?.ticket_type === 'location_item' || item?.checklist_item?.location ? 'Location' : 'Item';
  const locationValue = item?.checklist_item?.item_location?.item?.item_description
    || item?.checklist_item?.location?.location_description
    || item?.location_name
    || item?.item_name
    || 'General Ticket';
  const canEdit = item?.Assigned_by == user?.Emp_Code || permission.includes("Inventory_Auth") || permission.includes('Checklist_Auth') || permission.includes('global_admin');

  return (
    <>
      <Box
        ref={setNodeRef}
        {...attributes}
        {...listeners}
        onClick={(e) => e.stopPropagation()}
        sx={{
          ...style,
          padding: 0,
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0px 1px 6px rgba(0,0,0,0.08)',
          border: '1px solid #F0F0F0',
          transition: 'box-shadow 0.2s',
          '&:hover': { boxShadow: '0px 4px 14px rgba(0,0,0,0.12)' },
        }}
      >
        {/* Header */}
        <Box sx={{ px: 2, pt: 1.5, pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}>
            <Typography
              fontWeight={700}
              fontSize="14px"
              sx={{
                flex: 1,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                color: '#1A1A2E',
              }}
            >
              {item?.content || 'No Title'}
            </Typography>
            <span
              style={{ fontSize: '13px', cursor: 'pointer', color: '#D92D20', fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0 }}
              onClick={() => setShow(true)}
            >
              Details →
            </span>
          </Box>

          {item?.employee_code == user?.Emp_Code && ticketType === 'allTicket' && (
            <Box sx={{ mt: 0.5 }}>
              <span style={{ background: '#ECFDF3', color: '#027A48', fontSize: '11px', fontWeight: 600, borderRadius: '20px', padding: '2px 10px', border: '1px solid #A9EFC5' }}>
                My Ticket
              </span>
            </Box>
          )}
        </Box>

        <Box sx={{ height: '1px', backgroundColor: '#F0F0F0', mx: 0 }} />

        {/* Body */}
        <Box sx={{ px: 2, py: 1.5 }}>
          {item?.description && (
            <Typography sx={{ fontSize: '13px', color: '#667085', mb: 1.5, lineHeight: 1.5 }}>
              {item.description.substring(0, limit)}{item.description.length > limit ? '…' : ''}
            </Typography>
          )}

          {/* Assignee row */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
            <PersonOutlineIcon sx={{ fontSize: '15px', color: '#98A2B3' }} />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flex: 1, minWidth: 0 }}>
              <Box sx={{
                width: 22, height: 22, borderRadius: '50%', background: '#BF1D2D',
                color: '#fff', fontSize: '10px', fontWeight: 700,
                display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
              }}>
                {initials}
              </Box>
              <Typography sx={{ fontSize: '13px', color: '#344054', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {assigneeName || '—'}
              </Typography>
              {canEdit && (
                <Tooltip title="Reassign">
                  <EditIcon
                    sx={{ fontSize: '14px', color: '#98A2B3', cursor: 'pointer', flexShrink: 0, '&:hover': { color: '#BF1D2D' } }}
                    onClick={() => { setAssignModal(true); loadEmployees(); setSelectedId(item?.id); setSelectedEmp(item?.employee_code); }}
                  />
                </Tooltip>
              )}
            </Box>
          </Box>

          {/* Date row */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
            <CalendarTodayOutlinedIcon sx={{ fontSize: '15px', color: '#98A2B3' }} />
            <Typography sx={{ fontSize: '13px', color: '#344054' }}>
              {moment(item.date).format('MM/DD/YYYY')}
            </Typography>
          </Box>

          {/* Location row */}
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 0.5 }}>
            <LocationOnOutlinedIcon sx={{ fontSize: '15px', color: '#98A2B3', mt: '1px' }} />
            <Typography sx={{ fontSize: '13px', color: '#344054', lineHeight: 1.4 }}>
              <span style={{ color: '#667085', fontWeight: 500 }}>{locationLabel}: </span>
              {locationValue}
            </Typography>
          </Box>

          {/* Location path pills */}
          {item?.location_path?.length > 0 && (
            <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '4px', mt: 0.75, mb: 0.5, overflowX: 'auto', scrollbarWidth: 'none' }}>
              {item.location_path.map((loc, index) => (
                <span key={index} style={{
                  fontSize: '11px', background: '#F2F4F7', color: '#344054',
                  borderRadius: '20px', padding: '2px 10px', border: '1px solid #D0D5DD',
                  whiteSpace: 'nowrap', fontWeight: 500,
                }}>
                  {loc}
                </span>
              ))}
            </Box>
          )}
        </Box>

        {/* Footer */}
        <Box sx={{ height: '1px', backgroundColor: '#F0F0F0' }} />
        <Box sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#FAFAFA' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {canEdit && (
              <Tooltip title="Edit ticket">
                <IconButton size="small" sx={{ color: '#98A2B3', '&:hover': { color: '#BF1D2D', background: '#FFF1F1' } }}
                  onClick={() => { setEditModal(true); setEditId(item?.id); }}
                >
                  <EditIcon sx={{ fontSize: '17px' }} />
                </IconButton>
              </Tooltip>
            )}
            {item?.Assigned_by == user?.Emp_Code && (
              <Tooltip title="Delete ticket">
                <IconButton size="small" sx={{ color: '#98A2B3', '&:hover': { color: '#D92D20', background: '#FFF1F1' } }}
                  onClick={() => setDeleteModal(true)}
                >
                  <DeleteIcon sx={{ fontSize: '17px' }} />
                </IconButton>
              </Tooltip>
            )}
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {item.image && (
              <Tooltip title="View image">
                <a href={item.image} target="_blank" rel="noopener noreferrer">
                  <img src={item.image} height="28px" width="28px"
                    style={{ borderRadius: '50%', border: '2px solid #fff', boxShadow: '0 0 0 1px #D0D5DD', objectFit: 'cover', cursor: 'pointer' }} />
                </a>
              </Tooltip>
            )}
            {item.secondaryImage && (
              <Tooltip title="View secondary image">
                <a href={item.secondaryImage} target="_blank" rel="noopener noreferrer">
                  <img src={item.secondaryImage} height="28px" width="28px"
                    style={{ borderRadius: '50%', border: '2px solid #fff', boxShadow: '0 0 0 1px #D0D5DD', objectFit: 'cover', cursor: 'pointer', marginLeft: '-8px' }} />
                </a>
              </Tooltip>
            )}
          </Box>
        </Box>
      </Box>


      <Modal show={show} onHide={() => {
				setShow(false)
				ticketApi()
			}} size='xl'>
        <Modal.Body className='p-0'>
          <TicketModal
            show={show}
            setShow={setShow}
            item={item}
            ticketApi={ticketApi}
          />
        </Modal.Body>
      </Modal>

			<Modal show={deleteModal} onHide={() => {
					setDeleteModal(false)
				}} size='md'>
					<Modal.Header closeButton>
						<Modal.Title>Delete Ticket</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<DeleteModal
							deleteModal = {deleteModal}
							setDeleteModal = {setDeleteModal}
							item = {item}
							ticketApi={ticketApi}
						/>
					</Modal.Body>
				</Modal>

				<Modal show={editModal} onHide={() => {
					setEditModal(false)
				}} size='md'>
					<Modal.Header closeButton>
						<Modal.Title>Edit Ticket</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<EditModal
							editModal = {deleteModal}
							setEditModal = {setEditModal}
							item = {item}
							ticketApi={ticketApi}
							editId = {editId}
						/>
					</Modal.Body>
				</Modal>

				<Modal show={assignModal} onHide={() => {
					setAssignModal(false)
					setTicketAssignTo(null)
				}} size='md'>
					<Modal.Header closeButton>
						<Modal.Title>Assign to</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Grid item xs={12} sm={6} md={12}>
							<label className='my-2'>Assign Ticket Update To</label>
							<Autocomplete
								className="w-100"
								options={employees}
								value={ticketAssignTo}
								onChange={(e, newValue) => setTicketAssignTo(newValue)}
								sx={{
									"& .MuiInputBase-root": {
										height: "48px",
										fontSize: "14px",
										display: "flex",
										alignItems: "center"
									}
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										placeholder="Select Employee"
										className="w-100"
									/>
								)}
							/>
						</Grid>
						<Row className="mt-3 mb-2">
							<Col md='auto'>
								<ButtonTheme type='submit' variant="filled" color='#f5f5f5' className='mt-1' onClick = {() => setAssignModal(false)}>
									Cancel
								</ButtonTheme>
							</Col>
							<Col md='auto'>
								<ButtonTheme type='submit' variant="filled" color='primary' className='mt-1' onClick={UpdateEmployee}>
									Upadte
								</ButtonTheme>
							</Col>
						</Row>
					</Modal.Body>
				</Modal>
			</>
  );
};

const columnConfig = {
  todo:      { color: '#F79009', chipBg: '#FFF3CD', chipText: '#856404' },
  progress:  { color: '#2E90FA', chipBg: '#CCE5FF', chipText: '#004085' },
  completed: { color: '#12B76A', chipBg: '#D4EDDA', chipText: '#155724' },
  cancelled: { color: '#F04438', chipBg: '#F8D7DA', chipText: '#721C24' },
};

export const DroppableColumn = ({ columnId, column, children }) => {
  const { setNodeRef } = useDroppable({ id: columnId });
  const config = columnConfig[columnId] || { color: '#cccccc', chipBg: '#E2E3E5', chipText: '#383D41' };

  return (
    <Paper
      ref={setNodeRef}
      style={{
        padding: "1rem",
        backgroundColor: "#F9FAFB",
        borderTop: `5px solid ${config.color}`,
        borderRadius: "12px",
        marginBottom: '10px',
        boxShadow: '0px 1px 4px rgba(0,0,0,0.06)',
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
        <span style={{
          background: config.chipBg,
          color: config.chipText,
          borderRadius: '12px',
          padding: '4px 14px',
          fontSize: '13px',
          fontWeight: 600,
        }}>
          {column.name}
        </span>
        <span style={{ fontSize: '12px', color: '#888', fontWeight: 500 }}>
          {column.items.length} {column.items.length === 1 ? 'ticket' : 'tickets'}
        </span>
      </div>
      <Box
        sx={{
          height: "100vh",
          overflow: "scroll",
          marginTop: "16px",
          scrollbarWidth: "none",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
        {column.items.length === 0 && (
          <p style={{ textAlign: "center", color: "#aaaaaa", fontSize: '13px', marginTop: '24px' }}>
            No tickets in {column.name}
          </p>
        )}
      </Box>
    </Paper>
  );
};
